// Utils
import rawFromText from './rawFromText';
import rawFromHtml from './rawFromHtml';

// Types
import { RawDraftContentState } from 'draft-js';

export default (html?: string, text?: string): RawDraftContentState | undefined =>
    rawFromHtml(html) || rawFromText(text);
